import { useDropzone, type DropzoneState } from "react-dropzone";
import { ActorRefFrom } from "xstate";
import {
  acceptedExtensions,
  acceptedPointcloudFiles,
} from "../utils/fileAcceptance";
import { LidarMachineContext } from "../state/lidarMachine";

export function usePointCloudDropzone(
  lidarMachine?: ActorRefFrom<typeof LidarMachineContext.machine>
): DropzoneState {
  const defaultLidarMachine = LidarMachineContext.useActorRef();
  const machine = lidarMachine || defaultLidarMachine;

  return useDropzone({
    accept: acceptedExtensions.pointclouds,
    onDrop: (acceptedFiles) => {
      if (acceptedFiles.length === 0) return;

      machine.send({
        type: "ADD_FILES",
        files: acceptedPointcloudFiles(acceptedFiles),
      });
    },
  });
}
